module.exports = __webpack_public_path__ + "img/Autogenerationtestgray.02737d18.svg";